import { useCallback, useEffect, useRef } from 'react'

import router from '@/router'
import { useSession } from '@/lib/auth'

export function useGetAuth() {
  const { data, isPending } = useSession()
  const resolveRef = useRef<((isAuthenticated: boolean) => void) | null>(null)
  const promiseRef = useRef<Promise<boolean> | null>(null)

  useEffect(() => {
    router.invalidate()
    if (!isPending && resolveRef.current) {
      const isAuthenticated = !!data?.user
      resolveRef.current(isAuthenticated)
      resolveRef.current = null
      promiseRef.current = null
    }
  }, [isPending, data?.user])

  const waitForSession = useCallback((): Promise<boolean> => {
    if (!isPending) {
      return Promise.resolve(!!data?.user)
    }

    if (!promiseRef.current) {
      promiseRef.current = new Promise<boolean>((resolve) => {
        resolveRef.current = resolve
      })
    }

    return promiseRef.current
  }, [isPending, data?.user])

  return {
    isPending,
    isAuthenticated: !!data?.user,
    waitForSession,
  }
}
